const compareNotes = (note1, note2) =>
  Date.parse(note1.created_at) > Date.parse(note2.created_at) ? 1 : 0;

// eslint-disable-next-line import/prefer-default-export
export const sortNotes = notesList => {
  if (notesList === undefined || notesList === null) {
    return [];
  }
  return notesList.sort((a, b) => compareNotes(a, b));
};
